import {
  Button,
  Col,
  Empty,
  Flex,
  message,
  Modal,
  Popover,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import "./style.css";
import API from "../../services/api-request";
import SelectRack from "./SelectRack";

const SelectLayoutNew = ({ value, onChange, action }) => {
  const [selectedStorage, setSelectedStorage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rackLocation, setRackLocation] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [rackData, setRackData] = useState(null);
  const [temporarySelected, setTemporarySelected] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const handleRackSelect = (rackData) => {
    onChange &&
      onChange({ ...rackData, warehouse_name: selectedStorage.warehouse_name });

    setShowModal(false);
  };

  const handleOpenModal = (id, name, row, section, temporary) => {
    if (!name) return;

    const codifiedName = temporary
      ? "T-CS" + name.split(" ")[2]
      : "CS" + name.split(" ")[2];

    setReloadKey((prev) => prev + 1);
    setShowModal(true);
    setRackLocation(`${codifiedName}-${row}${section}`);
    setRackData({ id, name, row, section });
  };

  const getAreaData = (id = 1) => {
    setLoading(true);

    API.Get(`area/map`)
      .then((res) => {
        const data = res?.data;

        setSelectedStorage(data.filter((item) => item.warehouse_id === id)[0]);
        setWarehouses(
          data.map((item) => ({
            id: item.warehouse_id,
            warehouse_name: item.warehouse_name,
          })),
        );
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch area data!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAreaData();
  }, []);

  return (
    <>
      <Flex gap={8}>
        {warehouses.map(
          (item, index) =>
            !item.warehouse_name.includes("Temporary") && (
              <Button
                variant={
                  selectedStorage?.warehouse_name === item?.warehouse_name
                    ? "solid"
                    : "outlined"
                }
                color="primary"
                style={{
                  borderRadius: 20,
                  padding: "1rem",
                }}
                key={index}
                onClick={() => {
                  setTemporarySelected(false);
                  getAreaData(item?.id);
                }}
              >
                {item?.warehouse_name}
              </Button>
            ),
        )}
        <Popover
          content={
            <Row gutter={8}>
              {warehouses.map(
                (item, index) =>
                  item.warehouse_name.includes("Temporary") && (
                    <Col span={8}>
                      <Button
                        variant={
                          selectedStorage?.warehouse_name ===
                          item?.warehouse_name
                            ? "solid"
                            : "outlined"
                        }
                        color="primary"
                        style={{
                          borderRadius: 20,
                          padding: "1rem",
                        }}
                        key={index}
                        onClick={() => {
                          setTemporarySelected(true);
                          getAreaData(item?.id);
                        }}
                      >
                        {item?.warehouse_name}
                      </Button>
                    </Col>
                  ),
              )}
            </Row>
          }
        >
          <Button
            variant={temporarySelected ? "solid" : "outlined"}
            color="primary"
            style={{
              borderRadius: 20,
              padding: "1rem",
            }}
          >
            Temporary Area
          </Button>
        </Popover>
      </Flex>
      {selectedStorage?.rows?.length > 0 ? (
        loading ? (
          <Flex
            justify="center"
            align="center"
            style={{ marginTop: "10rem", marginBottom: "10rem" }}
          >
            <Spin size="large" />
          </Flex>
        ) : (
          <Row gutter={8}>
            {selectedStorage?.rows.map((row, index) => (
              <Col span={4} key={index}>
                <Flex justify="center">
                  <div>
                    <h2 style={{ textAlign: "center" }}>{row?.row_number}</h2>
                    <Row gutter={4}>
                      {row?.sections?.map((section, index) => (
                        <Col
                          key={index}
                          span={row?.sections?.length > 1 ? 12 : 24}
                        >
                          <Button
                            color="primary"
                            variant="outlined"
                            className="section-button"
                            onClick={() => {
                              handleOpenModal(
                                selectedStorage?.warehouse_id,
                                selectedStorage?.warehouse_name,
                                row?.row_number,
                                section?.section,
                                selectedStorage.warehouse_name.includes(
                                  "Temporary",
                                )
                                  ? true
                                  : false,
                              );
                            }}
                          >
                            <div>
                              {section?.section}
                              <br />
                              {section?.occupied_areas +
                                "/" +
                                (+section?.empty_areas +
                                  +section?.occupied_areas)}
                              <div>{Math.round(section?.total_weight)} Kg</div>
                            </div>
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Flex>
              </Col>
            ))}
          </Row>
        )
      ) : loading ? (
        <Flex
          justify="center"
          align="center"
          style={{ marginTop: "10rem", marginBottom: "10rem" }}
        >
          <Spin size="large" />
        </Flex>
      ) : (
        <Empty
          // description="Choose Storage"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ marginTop: "10rem" }}
        />
      )}

      <Modal
        title={rackLocation}
        closeIcon={false}
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={"40%"}
      >
        <SelectRack
          data={rackData}
          location={rackLocation}
          onRackSelect={handleRackSelect}
          action={action}
          open={showModal}
          reloadKey={reloadKey}
        />
      </Modal>
    </>
  );
};

export default SelectLayoutNew;
